/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type TopNoticeInfo = {
    ID: string;
    TITLE: string;
    CONTT: string;
    EXPST: string;
    EXPEND: string;
    LUSE: TopNoticeInfo.LUSE;
    LURL?: string;
    LTG?: TopNoticeInfo.LTG;
    EXPSTA?: TopNoticeInfo.EXPSTA;
    PGSTA?: TopNoticeInfo.PGSTA;
};

export namespace TopNoticeInfo {

    export enum LUSE {
        Y = 'Y',
        N = 'N',
    }

    export enum LTG {
        CURRENT_TAB = 'CURRENT_TAB',
        NEW_TAB = 'NEW_TAB',
        NEW_WINDOW = 'NEW_WINDOW',
    }

    export enum EXPSTA {
        Y = 'Y',
        N = 'N',
    }

    export enum PGSTA {
        WAITING = 'WAITING',
        PROGRESS = 'PROGRESS',
        END = 'END',
    }


}

